<div class="tab-component-wrapper">
    <div class="training-name-wrapper">
        <span class="training-name">{{ trainingName }}</span>
    </div>
    <div class="tabs-wrapper">
        <div
            class="tab-element"
            [ngClass]="{ active: tab === selectedTab }"
            *ngFor="let tab of tabs"
            (click)="onTabClick(tab)"
            [id]="tab + '-tab'"
        >
            <span class="tab-element-circle"></span>
            <span class="tab-element-value"
                >{{ getTranslationKey(tab) | translate }}
            </span>
        </div>
    </div>
    <div class="tab-content" *ngIf="trainingLoaded" @fadeIn>
        <app-edit-scene
            *ngIf="selectedTab === SplitScreenTab.SCENE"
            [trainingId]="trainingId"
            [editingIsDisabled]="editingIsDisabled"
            @fadeIn
        ></app-edit-scene>
        <app-cost-function
            *ngIf="selectedTab === SplitScreenTab.COST_FUNCTION"
            [trainingId]="trainingId"
            [editingIsDisabled]="editingIsDisabled"
            @fadeIn
        ></app-cost-function>
        <app-algorithm
            #beforeStartComponent
            *ngIf="selectedTab === SplitScreenTab.ALGORITHM"
            [trainingId]="trainingId"
            [trainingType]="trainingType"
            [editingIsDisabled]="editingIsDisabled"
            @fadeIn
        ></app-algorithm>
        <app-neural-network
            #beforeStartComponent
            *ngIf="selectedTab === SplitScreenTab.NETWORK_ARCHITECTURE && (containerType === ContainerType.PROJECT_MOTORIC || isExperimental)"
            [trainingId]="trainingId"
            [trainingType]="trainingType"
            [editingIsDisabled]="editingIsDisabled"
            @fadeIn
        ></app-neural-network>
        <app-evaluation
            *ngIf="selectedTab === SplitScreenTab.EVALUATION"
            [training]="training"
            @fadeIn
        ></app-evaluation>
        <app-img-db
            #beforeStartComponent
            *ngIf="selectedTab === SplitScreenTab.IMAGE_DB"
            [trainingId]="trainingId"
            [isDbFromTraining]="true"
            [canEdit]="!editingIsDisabled"
            @fadeIn
        ></app-img-db>
        <div class="empty-selection" *ngIf="!selectedTab" @fadeIn>
            <div class="arrow"></div>
            <span class="text">
                {{
                    'projectSplitScreen.components.tabs.emptySelection'
                        | translate
                }}
            </span>
        </div>
    </div>
    <div class="spinner-wrapper" *ngIf="!trainingLoaded">
        <div class="tryb-design-spinner"></div>
    </div>
</div>
